import React from 'react'
import Image from 'components/image/image'
import './block-gallery.sass'

const getImages = (data) => {
  return data.images.map((image, i) => {
    return (
      <div
        key={i}
        className="BlockGallery__col">
        <figure className="BlockGallery__figure">
          <Image image_url={`content/${image}`}
                 className="img-fluid"
                 alt={data.content[i]} />
          {data.content[i] &&
            <figcaption className="
              BlockGallery__caption
              k-text--mono
              pt-2
              text-center">
              {data.content[i]}
            </figcaption>
          }
        </figure>
      </div>
    )
  })
}

const BlockGallery = ({ data }) => {
  return (
    <section className="BlockGallery k-section container-fluid">
      <div className="BlockGallery__grid k-max-width--1">
        {getImages(data)}
      </div>
    </section>
  )
}

export default BlockGallery
